const context = require.context('./', true, /\.js$/);
const keys = context.keys().filter(item => item !== './index.js');

export default keys.map(item => {
  return context(item).default;
});
